// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Oysz","info":"Note_info__2yn5-","note":"Note_note__rLcRn","actions":"Note_actions__2ewP2"};